PuffinNotification = function () {
  const TYPE_INFO = 'notification-default';
  const TYPE_SUCCESS = 'notification-success';
  const TYPE_WARNING = 'notification-warning';

  const boxId = 'notification-box';
  const notificationId = 'displayed-notification';

  notify = function (message, type = TYPE_INFO, duration = null) {
    const box = document.getElementById(boxId);
    const mainPageBox = document.getElementById('main-page-content');
    box.innerHTML = "<div id='" + notificationId + "' class='site-notification " + type + "'><div>" + message + "</div><div onclick='removeNotification()' class='notification-close-wrapper'><div class='notification-close-icon'></div></div></div></div>";
    if(mainPageBox) {
      mainPageBox.classList.add('had-notification');
    }
    if (!!duration) {
      setTimeout(() => {
        removeNotification();
      }, duration * 1000)
    }
  };
  removeNotification = function () {
    elem = document.getElementById(notificationId);
    const mainPageBox = document.getElementById('main-page-content');
    if (elem) {
      elem.parentNode.removeChild(elem);
    }
    if(mainPageBox) {
      mainPageBox.classList.remove('had-notification');
    }
  };
  info = function (message, duration) {
    notify(message, TYPE_INFO, duration)
  };
  success = function (message, duration) {
    notify(message, TYPE_SUCCESS, duration)
  };
  warning = function (message, duration) {
    notify(message, TYPE_WARNING, duration)

  };

  return {
    info: info,
    success: success,
    warning: warning,
    clear: removeNotification
  }
}();
